export default "/images/haaretz.svg?bc81fcf242c64e1494c833ebeeacb3cb";